import React, { FC, useEffect, useState } from 'react';
import { dispatch } from 'use-bus';

const QrCodeManager: FC = () => {
    const [qrCodeDetected, setQrCodeDetected] = useState(false);
    const [keyboardBuffer, setKeyboardBuffer] = useState('');

    const handleKeyboard = (event: KeyboardEvent) => {
        // '⇈' Is embeded as the first character in all our QR codes.
        // This is needed for the iframed old-frontend to focus the main window (new-frontend)
        // We simply skip this char here...
        if (event.key === '⇈') {
            return preventKeyboardInput(event);
        }

        // '⇉' Is embeded as the second character in all our QR codes.
        // This is how we know the QR code input begins.
        if (event.key === '⇉') {
            setQrCodeDetected(true);
            return preventKeyboardInput(event);
        }

        // '⇇' Is embeded as the last character in all our QR codes.
        if (event.key === '⇇') {
            setQrCodeDetected(false);
            readQrCode(keyboardBuffer || '');
            setKeyboardBuffer('');
            return preventKeyboardInput(event);
        }

        if (qrCodeDetected) {
            setKeyboardBuffer(keyboardBuffer + event.key);
            return preventKeyboardInput(event);
        }
        return true;
    };

    const readQrCode = (textData: string) => {
        try {
            const data = JSON.parse(textData.trim());
            if (!data.event) {
                throw new Error('QR data missing event property');
            }
            dispatch({ type: data.event, payload: data });
        } catch (error) {
            console.error('QR CODE ERROR:', error);
        }
    };

    const preventKeyboardInput = (event: KeyboardEvent) => {
        event.stopPropagation();
        event.preventDefault();
        return false;
    };

    useEffect(() => {
        window.addEventListener('keydown', handleKeyboard);
        return () => {
            window.removeEventListener('keydown', handleKeyboard);
        };
    });

    return null;
};

export default QrCodeManager;
